import type { SchemaField } from '@cli-types/core-engine/schema.js'
export function findListFieldsWithRelationships(
  fields: SchemaField[]
): Array<{ field: SchemaField; path: string[] }> {
  const result: Array<{ field: SchemaField; path: string[] }> = []
  for (const field of fields) {
    if (field.type === 'list' && field.fields) {
      const hasRels = field.fields.some((f) => f.type === 'relationship' && f.relationship)
      if (hasRels) {
        result.push({ field, path: [field.name] })
      }
    }
  }
  return result
}
